import React from 'react';
import { SaleInfo } from '../types';
import './SaleBadge.css';

interface SaleBadgeProps {
  sale: SaleInfo;
  className?: string;
}

const SaleBadge: React.FC<SaleBadgeProps> = ({ sale, className = '' }) => {
  if (!sale.showBadge) return null;

  const badgeText = sale.badgeText || 'SALE';
  const textColor = sale.badgeColor || '#ffffff';
  const bgColor = sale.badgeBackgroundColor || '#ff4444';

  const badgeStyle: React.CSSProperties = {
    backgroundColor: bgColor,
    color: textColor,
    borderColor: textColor
  };

  return (
    <div className={`sale-badge ${className}`} style={badgeStyle}>
      <span className="sale-badge-text">{badgeText}</span>
    </div>
  );
};

export default SaleBadge;
